module.exports = __webpack_public_path__ + "ef75b853d18983f77e26336957f80951.svg";